const FormSubHeading = ({ title, className = "" }) => (
  <div className={`form-subheading ${className}`}>
    <span className="form-subheading-bar" />
    <span className="form-subheading-text">{title}</span>
  </div>
);

export default FormSubHeading;
